import { makeStyles } from "@mui/styles";

const useStyles: any = makeStyles((theme: any) => ({
  view: {
    display: "flex",
    height: "-webkit-fill-available",
    width: "100%",
    background: "#fff",
    overflowY: "auto",
    overflowX: "auto",
  },
  contentArea: {
    background: "white",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    flex: "1 1",
  },
  content: {
    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "column",
    marginTop: "10px",
  },
  headCells: {
    borderBottom: "none",
    padding: "0 15px",
    color: theme.tables.headerCell.color,
    fontWeight: theme.tables.headerCell.fontWeight,
    lineHeight: theme.tables.headerCell.lineHeight,
    letterSpacing: theme.tables.headerCell.letterSpacing,
    backgroundColor: theme.tables.headerCell.backgroundColor,
    textTransform: theme.tables.headerCell.textTransform,
    fontFamily: theme.tables.headerCell.fontFamily,
    height: 45,
    fontSize: 13,
  },
  rowCell: {
    color: theme.tables.tableCell.color,
    fontSize: theme.tables.tableCell.fontSize,
    fontFamily: theme.tables.tableCell.fontFamily,
    padding: theme.tables.tableCell.padding,
  },
  versionSuffix: {
    fontSize: "0.7em",
    verticalAlign: "top",
    lineHeight: "normal",
    marginLeft: "2px",
  },
  sharedButtonStyle: {
    width: "90px",
    height: "40px",
    borderRadius: "4px",
    fontSize: "16px",
    fontWeight: 500,
    margin: "15px 10px",
    marginBottom: "15px",
    padding: "0",
  },
  submitButton: {
    backgroundImage: theme.gradiants.button,
    color: "#fdfdfe",
  },
  dialogPaper: {
    width: "90%",
    maxWidth: "960px",
    minWidth: "480px",
    height: "92vh",
    maxHeight: "92vh",
    display: "flex",
    flexDirection: "column",
    margin: "16px",
  },
  dialogContainer: {
    // Center within main content (viewport minus 250px sidebar)
    paddingLeft: "250px",
    boxSizing: "border-box",
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto",
    overflow: "hidden !important",
    paddingTop: "12px",
  },
  inputField: {
    padding: "5px",
    flex: "0 0 auto",
  },
  releaseNotesField: {
    marginTop: "16px",
    flex: "1 1 auto",
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    "& .MuiFormHelperText-root": {
      flex: "0 0 auto",
    },
    "& .MuiOutlinedInput-root": {
      flex: "1 1 auto",
      alignItems: "stretch",
      overflow: "hidden",
      minHeight: 0,
    },
    "& .MuiInputBase-inputMultiline": {
      height: "100% !important",
      maxHeight: "100%",
      overflowY: "auto !important",
      resize: "none",
      boxSizing: "border-box",
    },
  },
}));
export default useStyles;
